import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedRecipientResourceToEditId } from 'scenes/BulletinBoard/BulletinBoardSlice';
import { patchUpdateManualResource } from 'scenes/BulletinBoard/services/patchUpdateManualResource.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

export const updateManualResource = createAsyncThunk(
  'bulletinBoard/updateManualResource',
  async (updateAttributes, { getState }) => {
    const selectedManualResourceToEditId =
      selectSelectedRecipientResourceToEditId(getState());

    const selectedProjectId = selectSelectedProjectId(getState());

    const response = await patchUpdateManualResource(
      selectedProjectId,
      selectedManualResourceToEditId,
      updateAttributes
    );

    return response;
  }
);
